import SplashLoader from '@shared/components/loading/SplashLoader';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useTranslation } from 'react-i18next';

// TODO ADMIN PANEL: Update with actual current seats used and total seats and other metrics
// TODO ADMIN PANEL: Update to use analytics API
export default function MetricPageContent() {
    const { t } = useTranslation();
    const { currentOrg } = useCurrentOrgDetailsFetching();

    return <SplashLoader text="Coming soon." />;

    // if (!currentOrg || isInviteLoading) return <SplashLoader />;
    // if (!(currentOrg.isAdmin || currentOrg.canCreateAuthClients)) return <OrgNoAccessBanner />;
    // return (
    //     <>
    //         <CardSmallGrid>
    //             {invites && (
    //                 <NumberStatCard
    //                     title={invites.length.toString() ?? '0'}
    //                     description={t('common:organization.invite.stat', {
    //                         value: currentOrg.organization.maxMembers,
    //                     })}
    //                 />
    //             )}
    //         </CardSmallGrid>
    //     </>
    // );
}
